import { Message } from "Models/message";
import {
    ACTION,
    ADD_LOG_MESSAGE,
    AddLogMsgAction,
    UPDATE_LOG_MESSAGE,
    UpdateLogMsgAction,
    CLEAR_LOGS,
    SET_LOG,
    SetLogAction,
} from "Redux/actionTypes";

export interface Logs {
    [key: string]: Message[];
}

const initialState = {} as Logs;

export default function reduce(state = initialState, action: ACTION) {
    switch (action.type) {
        case ADD_LOG_MESSAGE: {
            const {
                payload: { uid, msg },
            } = action as AddLogMsgAction;

            return {
                ...state,
                [uid]: [...(state?.[uid] ?? []), msg],
            };
        }
        case UPDATE_LOG_MESSAGE: {
            const {
                payload: { uid, msg },
            } = action as UpdateLogMsgAction;

            const keys = Object.keys(state);
            const logUid = keys.find((l) =>
                state[l].some((m) => m.uid === uid)
            );

            if (!logUid) return state;

            return {
                ...state,
                [logUid]: (state?.[logUid] ?? []).map((m) =>
                    m.uid === msg.uid ? msg : m
                ),
            };
        }
        case SET_LOG: {
            const {
                payload: { uid, log },
            } = action as SetLogAction;
            return { ...state, [uid]: [...log] };
        }
        case CLEAR_LOGS: {
            return initialState;
        }
        default:
            return state;
    }
}
